import { Flex } from 'antd'
import { styled } from 'styled-components'

export const Theme = styled(Flex)`
  .added {
    background-color: rgba(0, 194, 129, 0.4);
    border-radius: 5px;
  }
  .removed {
    background-color: rgba(245, 61, 61, 0.4);
    border-radius: 5px;
  }
  *:has(> .added):not(:has(> .removed)) {
    background-color: rgba(0, 194, 129, 0.1);
    border-radius: 5px;
  }

  *:has(> .removed):not(:has(> .added)) {
    background-color: rgba(245, 61, 61, 0.1);
    border-radius: 5px;
  }
  p > * {
    display: inline;
    white-space: normal;
  }

  ::selection {
    background: rgba(100, 150, 255, 0.4);
  }
`
